// Game registry for the unified draftplan engine.
//
// The active game is chosen at build time:
//   REACT_APP_GAME=dota npm run build   (default)
//   REACT_APP_GAME=mlbb|hok|lol npm run build
//
// Each game is a config folder under games/<id>/. Games with their own
// component implementations (dota, mlbb) have mirrored module trees; hok and
// lol reuse the dota implementations with their own roster/config — see the
// shims in src/components, src/contexts, src/models, src/services.

import dota from './dota/config';
import mlbb from './mlbb/config';
import hok from './hok/config';
import lol from './lol/config';

const GAMES = { dota, mlbb, hok, lol };

const activeId = process.env.REACT_APP_GAME || 'dota';

if (!GAMES[activeId]) {
  throw new Error(`Unknown game "${activeId}". Available: ${Object.keys(GAMES).join(', ')}`);
}

export const game = GAMES[activeId];
export const allGames = GAMES;
export default game;
